import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer className="bg-gray text-center text-white">

                <div className="container p-4 pb-0">

                    <section className="mb-3">

                        <a className="btn btn-outline-light btn-floating m-1" href="https://www.facebook.com/ehrabby.00" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-facebook-f"></i
                        ></a>


                        <a className="btn btn-outline-light btn-floating m-1" href="https://twitter.com/EmaratHossain8" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-twitter"></i
                        ></a>


                        <a className="btn btn-outline-light btn-floating m-1" href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=emarathossain00@gmail.com" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-google"></i
                        ></a>


                        <a className="btn btn-outline-light btn-floating m-1" href="https://www.instagram.com/emarat_rabbi/" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-instagram"></i
                        ></a>


                        <a className="btn btn-outline-light btn-floating m-1" href="https://www.linkedin.com/in/emarat/" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-linkedin-in"></i
                        ></a>


                        <a className="btn btn-outline-light btn-floating m-1" href="https://github.com/Emarat" target="_blank" rel="noopener noreferrer" role="button"
                        ><i className="fab fa-github"></i
                        ></a>
                    </section>

                </div>



                <div className="text-center p-3">
                    <p className="text-white">© 2022 Copyright: MD EMARAT HOSSAIN</p>
                </div>

            </footer>
        </div>
    );
};

export default Footer;